/**
 * =============================================================================
 * ChartTypeToggle
 *
 * Botão compacto para alternar a visualização de gráficos entre barras e
 * linhas (ícone no canto superior direito do card). Compartilhado entre o
 * painel da plataforma (WL) e o Dashboard Financeiro do tenant.
 *
 * @version 2.0.0
 * RELEASE:
 *   2026-09-12 v2.0.0 - Promovido de `wl/financial/charts` para componente
 *                       compartilhado (sem mudança de comportamento).
 *   2026-07-21 v1.0.0 - Versão inicial.
 * =============================================================================
 */
import { BarChart3, LineChart as LineIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export type ChartTypeMode = 'bar' | 'line';

interface Props {
  value: ChartTypeMode;
  onChange: (mode: ChartTypeMode) => void;
  className?: string;
}

/** Toggle bar/line inline com ícones. */
export function ChartTypeToggle({ value, onChange, className }: Props) {
  // Alterna para o modo oposto ao atual.
  const toggle = () => onChange(value === 'bar' ? 'line' : 'bar');
  const Icon = value === 'bar' ? LineIcon : BarChart3;
  const label = value === 'bar' ? 'Ver como linhas' : 'Ver como barras';

  return (
    <Button
      type="button"
      variant="outline"
      size="icon"
      className={cn('h-7 w-7', className)}
      onClick={toggle}
      title={label}
      aria-label={label}
    >
      <Icon className="h-3.5 w-3.5" />
    </Button>
  );
}
